import { useEffect, useState } from 'react'
import { fileSelectors, useFileContainers } from 'Modules'
import { useSelector } from 'react-redux'
import { FieldNames } from 'Constants/FieldNames'

export const useFileApi = (fieldName: FieldNames) => {
	const [error, setError] = useState<string>('')
	const { setFileContainersList, fileContainersMap } = useFileContainers()

	const filesBlob = useSelector(fileSelectors.getFilesBlob)
	const fileContainersList = fileContainersMap.get(fieldName) || []

	useEffect(() => {
		setFileContainersList({
			fieldName,
			fileContainersList: fileContainersList?.length
				? fileContainersList?.map(({ file, ...args }) => {
						if (file && !file.preview) {
							const url = file.file
							const blobFile = filesBlob.get(url)
							if (blobFile) {
								file = { ...file, preview: window.URL.createObjectURL(blobFile) }
							}
						}
						return { file, ...args }
				  })
				: [],
		})
	}, [filesBlob.size])

	const clearFileContainersList = () => {
		setFileContainersList({ fieldName, fileContainersList: [] })
	}

	const deleteFileContainer = (fileName: string) => {
		const filteredFileContainersList = fileContainersList?.filter(
			(fileContainer) => fileName !== fileContainer.file.name
		)
		setFileContainersList({
			fieldName,
			fileContainersList: filteredFileContainersList,
		})
		return filteredFileContainersList
	}

	return {
		fileContainersList,
		setFileContainersList,
		clearFileContainersList,
		deleteFileContainer,
		error,
		setError,
	}
}
